<template>
  <div class="brand-primary tone-100 box d-flex justify-center align-center">
    <font-awesome-icon
      :icon="icon"
      class="brand-primary--text text--tone-400"
      size="xl"
    />
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>
